import { render, staticRenderFns } from "./BlockSubGroup2Helplist.vue?vue&type=template&id=32e206b3&"
import script from "./BlockSubGroup2Helplist.vue?vue&type=script&lang=js&"
export * from "./BlockSubGroup2Helplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports